import { encodedObjectsMap, getNamespace } from "@permutation-city/common";
import { useDozerQuery } from "../../queries/useDozerQuery";

export const IncentiveAction = {
  MineBlueprint: 0,
  BuildBlueprint: 1,
  BuildScaffold: 2,
  HitForceField: 3,
  FuelForceField: 4,
  Deposit: 5,
} as const;

export type RawResponse = {
  action: number;
  dataHash: string;
  tokenAmount: bigint;
  reputationAmount: bigint;
};

export type Incentive = {
  action: number;
  tokenAmount: bigint;
  reputationAmount: bigint;
};

export type Result = {
  [IncentiveAction.MineBlueprint]: Record<number, Incentive>;
  [IncentiveAction.BuildBlueprint]: Record<number, Incentive>;
  [IncentiveAction.BuildScaffold]: Record<number, Incentive>;
};

export function useIncentivesQuery() {
  const sqlQuery = `
SELECT "action", "dataHash", "tokenAmount", "reputationAmount"
FROM "${getNamespace("permutation")}Incentive"
WHERE "action" = ${IncentiveAction.MineBlueprint}
OR "action" = ${IncentiveAction.BuildBlueprint}
OR "action" = ${IncentiveAction.BuildScaffold}
`;

  return useDozerQuery<Result, [RawResponse[]]>({
    queryKey: ["incentives"],
    sqlQuery,
    select: (data) => {
      const incentivesData = data[0];
      const incentivesByAction = {
        [IncentiveAction.MineBlueprint]: {} as Record<number, Incentive>,
        [IncentiveAction.BuildBlueprint]: {} as Record<number, Incentive>,
        [IncentiveAction.BuildScaffold]: {} as Record<number, Incentive>,
      };

      if (incentivesData) {
        for (const incentive of incentivesData) {
          const objectType = encodedObjectsMap[incentive.dataHash];
          const incentiveWithObjectType = {
            action: Number(incentive.action),
            tokenAmount: BigInt(incentive.tokenAmount),
            reputationAmount: BigInt(incentive.reputationAmount),
          };

          if (
            Number(incentive.action) === IncentiveAction.MineBlueprint ||
            objectType === 1 // TODO: air
          ) {
            incentivesByAction[IncentiveAction.MineBlueprint][objectType || 0] =
              incentiveWithObjectType;
          } else if (
            Number(incentive.action) === IncentiveAction.BuildBlueprint
          ) {
            incentivesByAction[IncentiveAction.BuildBlueprint][
              objectType || 0
            ] = incentiveWithObjectType;
          } else if (
            Number(incentive.action) === IncentiveAction.BuildScaffold
          ) {
            incentivesByAction[IncentiveAction.BuildScaffold][objectType || 0] =
              incentiveWithObjectType;
          }
        }
      }

      return incentivesByAction;
    },
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
  });
}
